// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumb_container__N60J_","mobileHidden":"Breadcrumb_mobileHidden__dZ2SP"};